import { useAdministrativeContext } from "../../../../../../pages/administrativePanel/administrativePanelContext"
import { useState, useCallback, useEffect } from "react"
import { toast } from "react-toastify"
import { api } from "../../../../../../services/api"
import { SpaceLoader } from "../../../../../loaders/spaceLoader"
import { GenericHorizontalBar } from "../../genericHorizontalBar"
import { useAuth } from "../../../../../../context/AuthContext"


export function GroupsGraphic() {
    const [groupsDatasForGraphic, setGroupsDatasForGraphic] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    const { 
        startDate, 
        endDate, 
        listBusinessToFilter,
        listSalesChannelsId 
    } = useAdministrativeContext()

    const { signOut } = useAuth()
   
    const fetchData = useCallback(async () => {
        setIsLoading(true)
        let obj = {
            startDate: startDate,
            endDate: endDate,
            business: listBusinessToFilter,
            salesChannels: listSalesChannelsId
        }

  
        try{
            await api.post('/getGroupsGraphic' , obj, {
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('@Inoveclube:token')
                }
            }).then(response => setGroupsDatasForGraphic(response.data))
            setIsLoading(false)

        }catch(error){
            if(error.response){
                if(error.response.status === 401 || error.response.status === 500){
                    signOut()
                    toast.warning('Sua sessão foi expirada')
                }else{
                    toast.error(error.response.data.message)
                }
            }else{
                toast.error(error.message)
            }        
        }
    }, [endDate, signOut, startDate, listBusinessToFilter, listSalesChannelsId])
    
    
    useEffect(() => {
        let subscribed = true

        if(subscribed && startDate !== '' && endDate !== '')
            fetchData()

        return () => (subscribed = false)
    }, [fetchData, startDate, endDate])


    if(isLoading){
        return <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)" /> 
    }else{
        return(
            <>
                {
                    groupsDatasForGraphic.length > 0 ?
                    <GenericHorizontalBar datasForGraphic={groupsDatasForGraphic} animationBar={true}/>
                    :<p className="withoutInformations">Nenhuma informação</p>
                }
            </>
        )
    }
   
}
